import * as t from './actionTypes';
import { ReducerState } from './types';

export const initialState = {
  changeLog: [],
  featureFlags: [],
  fetching: false,
  fetchingChangeLog: false,
  users: [],
};

const featureFlagsReducer = (
  state: ReducerState = initialState,
  action: { type: string; [key: string]: any },
) => {
  switch (action.type) {
    /*--------------------------------------------------------------------------------------------*/
    /* Fetch Feature Flag Change Log Actions                                                      */
    /*--------------------------------------------------------------------------------------------*/
    case t.FETCH_CHANGE_LOG: {
      return {
        ...state,
        fetchingChangeLog: action.fetchingChangeLog,
      };
    }
    case t.FETCH_CHANGE_LOG_ERROR: {
      return {
        ...state,
        fetchingChangeLog: action.fetchingChangeLog,
        error: action.error,
      };
    }
    case t.FETCH_CHANGE_LOG_RESPONSE: {
      return {
        ...state,
        fetchingChangeLog: action.fetchingChangeLog,
        changeLog: action.changeLog,
      };
    }

    /*--------------------------------------------------------------------------------------------*/
    /* Fetch Feature Flags Actions                                                                */
    /*--------------------------------------------------------------------------------------------*/
    case t.FETCH_FEATURE_FLAGS: {
      return {
        ...state,
        fetching: action.fetching,
      };
    }
    case t.FETCH_FEATURE_FLAGS_ERROR: {
      return {
        ...state,
        fetching: action.fetching,
        error: action.error,
      };
    }
    case t.FETCH_FEATURE_FLAGS_RESPONSE: {
      return {
        ...state,
        fetching: action.fetching,
        featureFlags: action.featureFlags,
      };
    }

    /*--------------------------------------------------------------------------------------------*/
    /* Save Feature Flag Actions                                                                  */
    /*--------------------------------------------------------------------------------------------*/
    case t.SAVE_FEATURE_FLAG: {
      return {
        ...state,
        featureFlags: state.featureFlags.map((featureFlag) => {
          if (featureFlag.feature === action.featureFlag.feature) {
            return { ...action.featureFlag, currentVersion: action.featureFlag.currentVersion + 1 };
          }
          return featureFlag;
        }),
      };
    }
    case t.SAVE_FEATURE_FLAG_ERROR: {
      return {
        ...state,
        error: action.error,
      };
    }

    /*------------------------------------------------------------------------------------------------*/
    /* Fetch Users Actions                                                          */
    /*------------------------------------------------------------------------------------------------*/
    case t.FETCH_USERS_RESPONSE: {
      return {
        ...state,
        users: action.users,
      };
    }
    case t.FETCH_USERS_ERROR: {
      return {
        ...state,
        error: action.error,
      };
    }

    default:
      return state;
  }
};

export default featureFlagsReducer;
